export default "__VITE_ASSET__hSPPsoak__"